// import { currencyFormat } from '../PDFContent'
import { dateTimeFormat } from '../../../Functions';
export function CDRHeadCompose(page, rowL, cdr, dataUrl) {
    var doc = cdr;
    var _y = rowL;
    var _space = page.spacingunit;
    var imgWidth = 55;
    var imgHeight = 25;
    var pageWidth = doc.internal.pageSize.getWidth();

    var imageX = (pageWidth / 2) - (imgWidth / 2);

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, imgWidth, imgHeight);
    _y += _space * 4;

    return _y;
}

export function CDRBodyCompose(page, rowL, cdr, data, user) {
    var doc = cdr;
    var _y = rowL;
    var _space = page.spacingunit;
    var margin = 10;
    var pageWidth = doc.internal.pageSize.getWidth();
    var columns = pageWidth / 5;
    // console.log('data', data)
    //current date
    var today = dateTimeFormat(new Date());
    var releasedDate = dateTimeFormat(new Date(data.dateReleased));
    //user
    const branch = user.branches.find(branch => branch.defaultBranch === true);

    doc.setFont("times", "bold");
    doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', (pageWidth / 2), _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;
    doc.text('CARGO DELIVERY RECEIPT', (pageWidth / 2), _y, null, null, 'center');
    _y += _space * 2;

    doc.text(`Date: ${today}`, margin, _y);
    _y += _space;
    doc.text(`Date Released: ${releasedDate}`, margin, _y);
    doc.text(`Booking Reference No : ${data.bookingRef}`, (pageWidth - margin), _y, null, null, 'right');
    _y += _space;
    doc.text(`CDR No: ${data.cargoDeliveryReceiptId}`, margin, _y);
    doc.text(`Branch: ${branch.branchName}`, (pageWidth - margin), _y, null, null, 'right');
    _y += _space * 2;

    // doc.text(`Old Booking Ref`, margin, _y);
    // doc.setFont("times", "bold");
    // var OBR = data.oldBookingRef ? data.oldBookingRef : '';
    // doc.text(`: ${OBR}`, (margin + 40), _y);
    // doc.setFont("times", "normal");
    // _y += _space;
    // doc.text(`Old Waybill Ref`, margin, _y);
    // doc.setFont("times", "bold");
    // var OWR = data.oldWaybillRef ? data.oldWaybillRef : '';
    // doc.text(`: ${OWR}`, (margin + 40), _y);
    // doc.setFont("times", "normal");
    // _y += _space * 2;

    let consignee = doc.splitTextToSize(data.consignee ? data.consignee : '', 145);
   
    doc.text(`Customer`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${consignee}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += (_space * consignee.length);

    doc.text(`Service Mode`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.modeOfDelivery}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    if(data.modeOfDelivery === "DTD" || data.modeOfDelivery === "Door-To-Door" || data.modeOfDelivery === "PTD" || data.modeOfDelivery === "Pier-To-Door"){
        _y += _space;
        doc.text(`Delivery Area`, margin, _y);
        doc.setFont("times", "bold");
        doc.text(`: ${data.consigneeAreaName}`, (margin + 45), _y);
        doc.setFont("times", "normal");
    }

    _y += _space * 2;

    doc.text(`Shipper`, margin, _y);
    doc.setFont("times", "bold");
    let shipper = doc.splitTextToSize(data.shipper ? data.shipper : '', 145);
    doc.text(`: ${shipper}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Shipper Preferred Name`, margin, _y)
    doc.setFont("times", "bold");
    doc.text(`: ${data.shipperPreferedName ? data.shipperPreferedName : ''}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Consignee`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${consignee}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += (_space * consignee.length);

    doc.text(`Consignee Preferred Name`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.consigneePreferedName ? data.consigneePreferedName : ''}`, (margin + 45), _y);
    doc.setFont("times", "normal");   
    _y += _space * 2;

    doc.text(`Trucker`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.truckerName ? data.truckerName : ''}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Driver`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.driver ? data.driver : ''}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Plate #`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.plateNum ? data.plateNum : ''}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.text(`Vessel`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.vessel}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Voyage Seq.`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.voyage}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space;

    doc.text(`Voyage Ref.`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.voyageRef}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.text(`Container Status`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${data.containerStatus}`, (margin + 45), _y);
    doc.setFont("times", "normal");
    _y += _space * 2;

    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space;
    doc.text(`Waybill`, margin, _y);
    doc.text(`Container #`, (columns * 1.5), _y);
    doc.text(`Seal #`, (columns * 2.8), _y);
    doc.text(`Qty`, (columns * 4), _y);
    // doc.text(`Storage`, (columns * 3.8), _y);
    _y += 2;
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(`${data.wayBillRef}`, margin, _y);
    if(data.cargoType === "FCL"){
        doc.text(`${data.containerVanNum ? data.containerVanNum : ''}`, (columns * 1.5), _y);
    }
    else {
        doc.text(`${data.cargoType ? data.cargoType : ''}`, (columns * 1.5), _y);
    }
    doc.text(`${data.cargoType === "FCL" && data.sealNum ? data.sealNum : ''}`, (columns * 2.8), _y);
    doc.text(`${data.quantityInTeu ? data.quantityInTeu : data.quantity}`, (columns * 4), _y);
    // doc.text(data.storage ? `${currencyFormat(data.storage)}` : '0', (columns * 3.8), _y);
    doc.setFont("times", "normal");
    _y += 2;
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space * 2;

    doc.text(`Remark`, margin, _y);
    let Remarks = data.remarks ? data.remarks : ''
    doc.text(`: ${Remarks}`, (margin + 45), _y);
    _y += _space * 2;

    doc.text(`Prepared By`, margin, _y);
    doc.setFont("times", "bold");
    doc.text(`: ${user.name}`, margin + 45, _y);
    doc.setFont("times", "normal");
    _y += _space * 3;

    const txt = doc.splitTextToSize(`On behalf of customer ${data.consignee}, I confirm that the above listed container/s were delivered and received in good condition:`, (pageWidth - (margin * 2)));
    doc.text(txt, margin, _y);

    _y += _space * (txt.length + 2);
    doc.text(`Received By:`, (pageWidth / 4), _y, null, null, 'center');
    doc.line(((pageWidth / 2) - (margin * 4) + 2), _y, (pageWidth / 2) + (margin * 4), _y);

    _y += _space;
    doc.text('Signature over Printed Name', (pageWidth / 2), _y, null, null, 'center');
}